// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"241":"d14fed89c8d3c652","4009":"374c5f99b2f2721a","9658":"e4fba2fd96197188"}[chunkId] + ".css";
};